//@flow
import * as Immutable from 'immutable';

import { Homebase } from 'common/models/flow/Homebase';
import type { HomebaseModelType } from 'common/models/flow/Homebase';

import { StructuredAddress } from './StructuredAddress';
import { Geometry } from './Geometry';
import { TeamId } from './TeamId';
import { AddressLatLng } from './AddressLatLng';

class InternalHomebase extends Homebase {
    static fromJS(json: HomebaseModelType): InternalHomebase {
        const state: Object = Object.assign({}, json);
        state.address = StructuredAddress.fromJS(state.address);
        state.geometry = Geometry.fromJS(state.geometry);
        state.teams = Immutable.List(state.teams).map(item =>
            TeamId.fromJS(item)
        );
        return new this(Immutable.Map(state));
    }

    getAddressLatLng = () => {
        const {
            address,
            geometry: { latLng }
        } = this;

        return AddressLatLng.fromJS({
            address,
            latLng
        });
    };

    getPlaceName() {
        return this.address.placeName;
    }

    getAddressString() {
        const { placeName, formattedAddress } = this.address;
        return `${placeName ? `${placeName}, ` : ''}${formattedAddress || ''}`;
    }

    get address(): StructuredAddress {
        return this._state.get('address');
    }

    get geometry(): Geometry {
        return this._state.get('geometry');
    }

    get teams(): Immutable.List<TeamId> {
        return this._state.get('teams');
    }
}

export { InternalHomebase as Homebase };
